export const AlignLeft = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 4V28" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M12 7H26" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M12 13H22" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M12 19H26" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M12 25H21.8" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
</svg>`;
